import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import validator from 'validator';
import { parseFromCurrencyString } from 'modules/utils';
import { ValidationType } from '../../../types/ValidationType';

// TODO ovaj prefix treba doci u useru, zasad nek bude hardkodiran
export const PHONE_NUMBER_PREFIX = '+385';

export function useInputValidator() {
  const { t } = useTranslation();

  const validateField = useCallback(
    (
      rawValue: string | number | null | undefined,
      validationList: ValidationType[],
    ) => {
      const value = rawValue?.toString();

      if (validationList.includes(ValidationType.REQUIRED)) {
        if (validator.isEmpty(value || '')) {
          return t('validation.requiredError');
        }
      }
      if (validationList.includes(ValidationType.EMAIL)) {
        if (value && (!validator.isEmail(value || '') || value.length > 50)) {
          return t('validation.emailError');
        }
      }
      if (validationList.includes(ValidationType.PHONE)) {
        try {
          if (
            value &&
            (!validator.isNumeric(value || '', { no_symbols: true }) ||
              value.length < 7)
          ) {
            return t('validation.phoneError');
          }
        } catch (e) {
          return t('validation.phoneError');
        }
      }
      if (validationList.includes(ValidationType.IBAN)) {
        if (value && !validator.isIBAN(value || '')) {
          return t('validation.ibanError');
        }
      }
      if (validationList.includes(ValidationType.OIB)) {
        if (value && !validator.isNumeric(value || '')) {
          return t('validation.oibError');
        }
      }
      if (validationList.includes(ValidationType.ID_CARD)) {
        if (value && (!validator.isNumeric(value || '') || value.length > 10)) {
          return t('validation.idCardError');
        }
      }
      if (validationList.includes(ValidationType.PASSWORD)) {
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=])(?=\S+$).{8,20}$/;
        if (!passwordRegex.test(value ?? '')) {
          return t('validation.passwordError');
        }
      }
      if (validationList.includes(ValidationType.XSS)) {
        const xssRegex =
            /^[^<>]*$/;
        if (!xssRegex.test(value ?? '')) {
          return t('validation.xssError');
        }
      }
      if (validationList.includes(ValidationType.NUMERIC)) {
        if (value && !validator.isNumeric(value || '', { no_symbols: true })) {
          return t('validation.numericError');
        }
      }
      if (validationList.includes(ValidationType.PARTICIPATION)) {
        if (value && +parseFromCurrencyString(value) > 50) {
          return t('validation.notValidParticipation');
        }
      }
      return undefined;
    },
    [t],
  );

  return validateField;
}
